import { BoardNodeHandles } from "./board-node-handles";
import { NodeResizer, type NodeProps } from "@xyflow/react";
import { useCanvasEditability, useCanvasEditSession, useCanvasResizeSession } from "../../lib/canvas-editability";
import { patchNodeData } from "../../lib/canvas-commands";
import type { TextNodeData } from "../../types/board";

export function TextNode({ id, data, selected, isConnectable }: NodeProps) {
  const nodeData = data as unknown as TextNodeData;
  const { canEditDocument } = useCanvasEditability();
  const edit = useCanvasEditSession("text");
  const resize = useCanvasResizeSession();
  const updateText = (text: string) => {
    if (text !== (nodeData.text ?? "")) edit.update(patchNodeData(id, { text }));
  };

  const fontSize = nodeData.fontSize || 14;

  return (
    <>
      <NodeResizer
        {...resize}
        isVisible={!!selected && canEditDocument}
        minWidth={30}
        minHeight={20}
        lineClassName="!border-primary"
        handleClassName="!h-2.5 !w-2.5 !rounded-sm !border-2 !border-primary !bg-background"
      />
      <BoardNodeHandles type="text" isConnectable={isConnectable} />
      <div
        className="flex h-full w-full items-center px-1 py-0.5"
        onDoubleClick={edit.begin}
      >
        {edit.active ? (
          <input
            autoFocus
            className="nodrag nowheel w-full bg-transparent outline-none"
            style={{ fontSize }}
            defaultValue={nodeData.text}
            onBlur={(e) => {
              updateText(e.target.value);
              edit.finish();
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                updateText((e.target as HTMLInputElement).value);
                edit.finish();
              }
            }}
          />
        ) : (
          <span style={{ fontSize }}>{nodeData.text || "Text"}</span>
        )}
      </div>
    </>
  );
}
